import { render, staticRenderFns } from "./datatable.vue?vue&type=template&id=415e1454&"
import script from "./datatable.vue?vue&type=script&lang=ts&"
export * from "./datatable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('415e1454', component.options)
    } else {
      api.reload('415e1454', component.options)
    }
    module.hot.accept("./datatable.vue?vue&type=template&id=415e1454&", function () {
      api.rerender('415e1454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/Cotizador/datatable.vue"
export default component.exports